import type { JobsJobElasticSchemaWithId } from '@iconik-io/iconik-api/src/services/jobs';
import type { SettingsJobsDashboardWidgetSchema } from '@iconik-io/iconik-api/src/services/settings';

type SortOrder = 'asc' | 'desc';
export type WidgetType = NonNullable<SettingsJobsDashboardWidgetSchema['type']>;
export type JobType = JobsJobElasticSchemaWithId['type'];

export type SortType = { name: string; order: SortOrder };

export type JobWidgetFilters = {
  type: JobType[];
  status: string[];
  object_type: string[];
  date_created?: string;
  created_by?: string[];
  my_jobs: boolean;
  storage_id?: string[];
  automation_id?: string;
};

type JobWidgetOptions = {
  filters: JobWidgetFilters;
  columns: string[];
  sort: SortType[];
  limit: number;
};

/**
 * The domain settings type the dashboard widgets as a loose bag, while the
 * dashboard reads the shape below out of them.
 */
export const asJobWidgets = (widgets: object[]): JobWidgetSchemaPatched[] =>
  // biome-ignore lint/plugin: see above.
  widgets as JobWidgetSchemaPatched[];

export type JobWidgetSchemaPatched = {
  id: string;
  title: string;
  type: WidgetType;
  options: JobWidgetOptions;
};
